module.exports = __webpack_public_path__ + "img/2805.96a1cc71.png";